<template>
  <div class="row pb-5" id="cards">
    <div class="col-12">
      <div class="container-xxl">
        <div class="">

          <div class="cards">
            <div class="card">
              <h4>Acessibilidade</h4>
              <p>Garantimos recursos e espaços necessários para que nossos colaboradores sintam-se bem e para que se desenvolvam.</p>
            </div>
            <div class="card">
              <h4>Inclusão e Diversidade</h4>
              <p>98% dos nossos colaboradores afirmam se sentirem bem tratados, independentemente de idade, etnia e gênero.</p>
            </div>
            <div class="card">
              <h4>Equidade Racial</h4>
              <p>Trabalhamos para que a equidade racial seja nosso objetivo interno de negócio. </p>
            </div>
            <div class="card">
              <h4>Meio Ambiente</h4>
              <p>Nossos espaços físicos são projetados para que o desperdício dos recursos naturais seja mínimo.</p>
            </div>
            <div class="card">
              <h4>Educação</h4>
              <p>A Universidade Rendimento garante que nossos colaboradores tenham acesso a treinamentos e conteúdos exclusivos.</p>
            </div>
            <div class="card">
              <h4>Privacidade</h4>
              <p>Nosso time cumpre as normas exigidas pela Lei Geral de Proteção de Dados em todos os níveis de interação.</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Cards',

    data(){
      return {
      }
    },

    computed: {
    },

    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  #cards{
    padding: 0 40px;
  }

  .cards{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 30px;
    margin-left: -15px;
    margin-right: -15px;

    .card{
      width: calc(33% - 25px);
      min-height: 210px;
      background: rgba(217, 217, 217, 0.24);
      border-radius: 10px;
      border: none;
      margin: 0;
      text-align: left;
      padding: 20px;
      h4{
        color: #00CFD9;
        font-weight: 600;
      }
      p{
        color: #0A1D6F;
      }

      &:hover{
        background:#0A1D6F;
        p{
          color: #fff;
        }
      }

      @include media-breakpoint-down(md){
        width: 100%;
        margin: 2%;
      }

    }
  }
</style>